var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-68e2bcc7"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "pt-[0px] p-[0px]" };
const _hoisted_2 = { class: "confirmDetailsContainer" };
const _hoisted_3 = { class: "text-gray-900 font-semibold text-lg" };
const _hoisted_4 = { class: "text-gray-600 font-normal mt-[2px]" };
const _hoisted_5 = { class: "text-gray-600 font-normal mt-[2px]" };
import AppState from '@/states/view_appointment';
import { Trash01Icon } from '@gohighlevel/ghl-icons/24/outline';
import { UIModal, UIModalFooter, UIModalHeader } from '@gohighlevel/ghl-ui';
import { ref } from 'vue';
import { CalendarEventService } from '../../service/CalendarEventService';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DeleteAppointmentModal',
    props: {
        eventId: String,
        showModal: Boolean,
        onCancelClick: Function,
        onDeleteClick: Function,
    },
    setup(__props) {
        const props = __props;
        const isLoading = ref(false);
        // Function to be called on delete icon
        const onClickDelete = () => __awaiter(this, void 0, void 0, function* () {
            isLoading.value = true;
            // call deleteAppointment API with eventId and required params
            yield CalendarEventService.deleteAppointment(props.eventId, {
                locationId: AppState.locationId,
                source: 'appointments_page',
                channel: 'web_app',
            });
            isLoading.value = false;
            props.onDeleteClick();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                id: "confirmation-modal",
                show: __props.showModal,
                class: _normalizeClass({ 'pointer-events-none': isLoading.value })
            }, {
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        id: "delete-appointment-modal-header",
                        type: "error",
                        icon: _unref(Trash01Icon),
                        onClose: _cache[0] || (_cache[0] = ($event) => (__props.onCancelClick()))
                    }, null, 8 /* PROPS */, ["icon"])
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(UIModalFooter), {
                        style: { fontfamily: 'Inter' },
                        id: "delete-appointment-modal-footer",
                        "positive-text": _ctx.$t('common.delete'),
                        "negative-text": _ctx.$t('common.cancel'),
                        onPositiveClick: onClickDelete,
                        onNegativeClick: _cache[1] || (_cache[1] = ($event) => (__props.onCancelClick())),
                        loading: isLoading.value,
                        type: "error"
                    }, null, 8 /* PROPS */, ["positive-text", "negative-text", "loading"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('common.delete_appointment')) + " ? ", 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('common.confirm_delete_message')), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('common.action_undone')), 1 /* TEXT */)
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["show", "class"]));
        };
    }
});
